import { updateSurveyToFillQuestion } from '../../../../../../store/actions/dataEntryFillASurveyActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import './SurveyTimeQuestion.css';

const SurveyTimeQuestion = ({ question, disabled, onChangeAlert }) => {
  const dispatch = useDispatch();
  const { id, config, answer, error } = question;
  const [value, setValue] = useState(answer && answer.length ? answer[0] : null);

  const onChangeInputValue = (newValue) => {
    dispatch(
      updateSurveyToFillQuestion({
        questionId: id,
        newData: { answer: newValue ? [newValue] : [], error: null }
      })
    );

    onChangeAlert();
  };

  useEffect(() => {
    setValue(answer && answer.length ? answer[0] : null);
  }, [answer]);

  return (
    <>
      <div style={{ width: '140px' }}>
        <TimePicker
          autoComplete={false}
          className='custom-text-field'
          id={`time-answer-${id}`}
          value={value ? new Date(value) : null}
          onChange={(value) => onChangeInputValue(value)}
          name='value'
          autoOk={true}
          fullWidth
          label='Add Time'
          disabled={disabled}
          format={config?.format || 'HH:mm a'}
          placeholder={config?.placeholder || 'HH:MM AM/PM'}
          slotProps={{
            textField: {
              variant: 'standard'
            }
          }}
        />
      </div>

      {error && <p className='survey-question__error-hint'>{error}</p>}
    </>
  );
};

export default SurveyTimeQuestion;
